import { FileIcon, FileTextIcon, ImageIcon, type LucideIcon, X } from "lucide-react";

import { cn } from "@/lib/utils";

function iconForMimeType(mimeType: string | null | undefined): LucideIcon {
  if (mimeType?.startsWith("image/")) {
    return ImageIcon;
  }
  if (mimeType === "application/pdf" || mimeType?.startsWith("text/")) {
    return FileTextIcon;
  }
  return FileIcon;
}

export function formatFileSize(size: number): string {
  if (size >= 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(2)} Mo`;
  }
  return `${(size / 1024).toFixed(2)} ko`;
}

export interface FileCardProps {
  name: string;
  size?: number | null;
  mimeType?: string | null;
  onRemove?: () => void;
  className?: string;
}

/** Selected-file row (icon by mime type, name, size, remove) — counterpart of the FileInput.vue list item. */
export function FileCard({ name, size, mimeType, onRemove, className }: FileCardProps) {
  const Icon = iconForMimeType(mimeType);

  return (
    <div
      className={cn(
        "flex items-center justify-between rounded-md border border-blue-200 bg-blue-50 py-2.5 pl-3 pr-3 text-sm leading-6",
        className,
      )}
    >
      <div className="flex w-0 flex-1 items-center">
        <Icon className="h-5 w-5 flex-shrink-0 text-blue-900" aria-hidden="true" />
        <div className="ml-3 flex min-w-0 flex-1 items-baseline gap-2">
          <span className="truncate font-medium text-blue-900" title={name}>
            {name}
          </span>
          {size != null ? (
            <span className="flex-shrink-0 text-xs text-blue-700">{formatFileSize(size)}</span>
          ) : null}
        </div>
      </div>
      {onRemove ? (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Supprimer le fichier"
          className="ml-3 rounded-md p-1 text-blue-900 hover:bg-blue-100 hover:text-blue-800"
        >
          <X className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  );
}
